module.exports = __webpack_public_path__ + "assets/img/2_871.cb1c02bf.jpg";